var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgTickDoneIconCheckConfirmLite = function SvgTickDoneIconCheckConfirmLite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 15,
    stroke: "#000",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 26c-.322 0-.644-.13-.89-.395l-4.792-5.129a1.415 1.415 0 010-1.903 1.2 1.2 0 011.778 0l3.904 4.178 7.804-8.357a1.2 1.2 0 011.778 0c.49.525.49 1.378 0 1.904l-8.695 9.307a1.214 1.214 0 01-.887.395z",
    fill: "#000"
  })));
};
export default SvgTickDoneIconCheckConfirmLite;